import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  TextField,
  Paper,
  Button,
  IconButton,
  Tooltip,
  Stack,
  useTheme,
  LinearProgress,
  Select,
  MenuItem,
  InputLabel,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import {
  explorePostData,
  fetchApidata,
  postApidata,
  postApidatawol,
  getDeployment,
  postDeployment,
  invoiceExploreGetData,
  postData,
  resetTrackingData,
  empAttendance,
  Attendance,
  AttendanceProcess,
  timeSheet,
  timeSheetPostData,
} from "../../../store/reducers/Formapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {
  // DataGrid,
  GridToolbarContainer,
  // GridToolbarColumnsButton,
  // GridToolbarFilterButton,
  // GridToolbarExport,
  // GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { DataGrid } from "@mui/x-data-grid";
import { useProSidebar } from "react-pro-sidebar";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import TimeSheetPDF from "../../reports/TimeSheetPdf";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import Edittimesheetreport from "./Edittimesheetreport";
import store from "../../../index";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-hot-toast";
import {
  CheckinAutocomplete,
  Employeeautocomplete,
  TimesheetEmployeeautocomplete,
} from "../../../ui-components/global/Autocomplete";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InvoicePDF from "../../reports/Invoicepdf";
import { getConfig } from "../../../config";
import { FaFileExcel } from "react-icons/fa";
import TimesheetExcel from "../../reports/TimesheetExcel";

const EditTimeSheet = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const mode = params.Mode;
  const dispatch = useDispatch();
  const isManager = sessionStorage.getItem("isManager");
  const EMPNAME = sessionStorage.getItem("EmpName");
  var recID = params.id;
  var accessID = params.accessID;
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const listViewData = useSelector((state) => state.listviewApi.rowData);
  const listViewColumn = useSelector((state) => state.listviewApi.columnData);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const CompanyID = sessionStorage.getItem("companyId");

  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  const sliceSubscriptionCode = SubscriptionCode.slice(-3);
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");

  const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");
  const config = getConfig();
  const baseurl1 = config.UAAM_URL;
  console.log("HeaderImg", HeaderImg, FooterImg);

  // useEffect(() => {
  //   dispatch(resetTrackingData());
  // }, []);
  const currentMonthNumber = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();
  console.log(currentYear, "currentyear");
  // useEffect(() => {
  //   // Get session values
  //   const savedProData = sessionStorage.getItem("timeproData");
  //   const savedEmpData = sessionStorage.getItem("timeempData");
  //   // const savedSelf = sessionStorage.getItem("timeuseCurrentEmp" || "true");
  //   const savedSelf = sessionStorage.getItem("timeuseCurrentEmp") ?? "true";
  //   const savedMonth = sessionStorage.getItem("timemonth");
  //   const savedYear = Number(sessionStorage.getItem("timeyear"));

  //   // Default to current month/year if session is empty

  //   const pro = savedProData ? JSON.parse(savedProData) : null;
  //   const emp = savedEmpData ? JSON.parse(savedEmpData) : null;
  //   const self = savedSelf === "true";

  //   const month = savedMonth || currentMonthNumber;
  //   const year = savedYear || currentYear;

  //   // Update states
  //   settimeproData(pro);
  //   settimeempData(self ? null : emp);
  //   settimeUseCurrentEmp(self);

  //   const data = {
  //     Month: month,
  //     Year: year,
  //     EmployeeID: self ? EMPID : emp?.RecordID || "",
  //     ProjectID: pro?.RecordID || "",
  //     CompanyID,
  //   };

  //   dispatch(timeSheet({ data }));
  // }, []);

  var QA = sessionStorage.getItem("qualityassurance");
  const AttendanceData = useSelector((state) => state.formApi.timeSheetData);
  const timeSheetLoading = useSelector((state) => state.formApi.timeSheetLoading);
  const projectName = useSelector((state) => state.formApi.projectName);
  const managerName = useSelector((state) => state.formApi.managerName);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const data = useSelector((state) => state.formApi.Data);
  const isLoading = useSelector((state) => state.formApi.loading);
  const [page, setPage] = React.useState(0);
  const [isFiltered, setIsFiltered] = React.useState(false);
  const [rowCount, setRowCount] = React.useState(0);
  const [pageSize, setPageSize] = useState(15);
  // const [rowCount, setRowCount] = useState(0);
  const [show, setScreen] = React.useState("0");
  const EMPID = sessionStorage.getItem("EmpId");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];
  const [selectedRow, setSelectedRow] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errorMsgData, setErrorMsgData] = useState(null);
const [appliedUseCurrentEmp, setAppliedUseCurrentEmp] = useState(true);

const queryObj = {
  Query: {
    AccessID: isManager === "1" ? "2119" : "2114",
    ScreenName: "Project",
    Filter: `parentID=${CompanyID} AND EmployeeID=${EMPID}`,
    Any: ""
  }
};









  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  const handleUnlock = async () => {
    const idata = {
      action: "update",
      DailyTaskRecordID: selectedRow?.RecordID,
      ApprovedBy: EMPID,
      ApprovedStatus: "",
      DateTime: formattedDate,
      Remarks: reason,
    };

    try {
      const response = await dispatch(timeSheetPostData({ idata }));

      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);
        dispatch(timeSheet({ data: getData }));
        handleDialogClose();
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      console.error("Error during timesheet post:", error);
      toast.error("Something went wrong!");
    }
  };
  const handleFilterChange = (newFilterModel) => {
    setIsFiltered(newFilterModel.items?.some((item) => item.value));
  };

  function AttendanceTool() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>List of Tasks</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }
  const [timeuseCurrentEmp, settimeUseCurrentEmp] = useState(true);

  const AttColumn = React.useMemo(() =>[
    {
      field: "slno",
      headerName: "SL#",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        // check if total visible rows = total dataset (means no filter/search applied)
        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          // filtering/search applied → restart from 1
          return index + 1;
        } else {
          // no filter/search → continuous numbering
          return page * pageSize + index + 1;
        }
      },
    },
    {
      field: "RecordID",
      headerName: "RecordID",
      width: 80,
      hide: true,
    },
    {
      field: "Code",
      headerName: "Code",
      width: 130,
      hide: true,
    },

    {
      field: "Date",
      headerName: "Date",
      headerAlign: "center",
      width: 80,
    },
    {
      field: "ProjectName",
      headerName: "Project",
      headerAlign: "center",
      width: 130,
    },
    // {
    //   field: "DesignationsName",
    //   headerName: "Function Name",
    //   width: 130,
    // },
    {
      field: "Description",
      headerName: "Task",
      headerAlign: "center",
      width: 600,
      renderCell: (params) => {
        const description = params.row.Description || "";
        const comments = params.row.Comments || "";
        const combinedText = `${description} || ${comments}`;

        return (
          <Tooltip title={combinedText} placement="top-start" arrow>
            <div
              style={{
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {combinedText}
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "ProjectCode",
      headerName: "ProjectCode",

      width: 130,
      hide: true,
    },

    {
      field: "FunctionCode",
      headerName: "FunctionCode",
      width: 130,
      hide: true,
    },
    {
      field: "Status",
      headerName: "Status",
      headerAlign: "center",
      width: 120,
    },
    {
      field: "TaskSource",
      headerName: "Source",
      width: 100,
      headerAlign: "center",
    },
    // ...(isManager === "1" && timeuseCurrentEmp === false
    ...(isManager === "1" && appliedUseCurrentEmp  === false
      ? [
        {
          field: "actions",
          headerName: "Actions",
          headerAlign: "center",
          width: 120,
          sortable: false,
          renderCell: (params) => {
            const isCompleted = params.row.Status === "Completed";
            const isApproved = params.row.Status === "AP";
            const isRejected = params.row.Status === "RJ";

            // Show nothing if not completed
            if (!isCompleted) return null;

            // If Approved or Rejected, show lock icon
            if (isApproved || isRejected) {
              return (
                <Tooltip title="Approved - Locked">
                  <IconButton onClick={() => handleDialogOpen(params.row)}>
                    <LockOpenIcon color="success" fontSize="small" />
                  </IconButton>
                </Tooltip>
              );
            }

            // Otherwise show Edit, Approve, Reject buttons
            return (
              <>
                {/* <Tooltip title="Edit">
                <IconButton
                  onClick={() => {
                    navigate(
                      `/Apps/Secondarylistview/TR263/Tasks/${EMPID}/EditTasks/${params.row.RecordID}/M`,
                      { state: { data: getData } }
                    );
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip> */}
                <Tooltip title="Edit">
                  <IconButton
                    onClick={() => {
                      const mode =
                        params.row.TaskSource === "Self" ? "S" : "M";

                      navigate(
                        `/Apps/Secondarylistview/TR263/Tasks/${EMPID}/EditTasks/${params.row.RecordID}/${mode}`,
                        { state: { data: getData } },
                      );
                    }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Approve">
                  <IconButton
                    onClick={async () => {
                      const idata = {
                        action: "update",
                        DailyTaskRecordID: params.row.RecordID,
                        ApprovedBy: EMPID,
                        Status: "AP",
                        DateTime: formattedDate,
                        Remarks: "aaa",
                      };

                      try {
                        const response = await dispatch(
                          timeSheetPostData({ idata }),
                        );
                        if (response.payload.Status === "Y") {
                          toast.success(response.payload.Msg);
                          dispatch(timeSheet({ data: getData }));
                          // dispatch(timeSheet());
                        } else {
                          toast.error(response.payload.Msg);
                        }
                      } catch (error) {
                        console.error("Error during timesheet post:", error);
                        toast.error("Something went wrong!");
                      }
                    }}
                  >
                    <DoneIcon fontSize="small" color="success" />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Reject">
                  <IconButton
                    onClick={async () => {
                      const idata = {
                        action: "update",
                        DailyTaskRecordID: params.row.RecordID,
                        ApprovedBy: EMPID,
                        Status: "RJ",
                        DateTime: formattedDate,
                        Remarks: "aaa",
                      };

                      try {
                        const response = await dispatch(
                          timeSheetPostData({ idata }),
                        );
                        if (response.payload.Status === "Y") {
                          toast.success(response.payload.Msg);
                          dispatch(timeSheet({ data: getData }));
                        } else {
                          toast.error(response.payload.Msg);
                        }
                      } catch (error) {
                        console.error("Error during timesheet post:", error);
                        toast.error("Something went wrong!");
                      }
                    }}
                  >
                    <CloseIcon fontSize="small" color="error" />
                  </IconButton>
                </Tooltip>
              </>
            );
          },
        },
      ]
      : []),
  ]);
  const filteredColumns = timeuseCurrentEmp
    ? AttColumn.filter((col) => col.field !== "actions")
    : AttColumn;

  const safeAttendanceData = Array.isArray(AttendanceData)
    ? AttendanceData
    : [];

  // Then:
  const ApprovedData = safeAttendanceData.filter(
    (row) => row.Status === "Approved",
  );

  const AttInitialvalues = {
    // code: data.Code,
    // description: data.Name,
    // Sal: data.Sal,
    // month: currentMonthNumber,
    // year: currentYear,
    timemonth: sessionStorage.getItem("timemonth") || currentMonthNumber,
    timeyear: Number(sessionStorage.getItem("timeyear")) || currentYear,
  };
  const [getData, setData] = useState("");

  // const attendaceFnSave = async (values) => {
  //   const data = {
  //     Month: values.month.toString(),
  //     Year: values.year,
  //     EmployeeID: useCurrentEmp ? EMPID : empData.RecordID,
  //     // EmployeeID: useCurrentEmp ? EMPID : values.empName?.RecordID,
  //     ProjectID: proData?.RecordID || "",
  //   };
  //   setData(data);
  //   dispatch(timeSheet({ data }));
  // };
  const attendaceFnSave = async (values) => {
    try {
      const data = {
        Month: values.timemonth?.toString() || "",
        Year: values.timeyear?.toString() || "",
        EmployeeID: timeuseCurrentEmp ? EMPID : timeempData?.RecordID || "", // safer optional chaining
        ProjectID: timeproData?.RecordID || "",
        CompanyID,
      };

      // Save these to sessionStorage (optional but useful if you want to persist the last used values)
      sessionStorage.setItem("timemonth", data.Month);
      sessionStorage.setItem("timeyear", data.Year);
      sessionStorage.setItem("timeproData", JSON.stringify(timeproData || {}));
      sessionStorage.setItem("timeempData", JSON.stringify(timeempData || {}));
      sessionStorage.setItem("timeuseCurrentEmp", timeuseCurrentEmp.toString());

      // Keep your state update and dispatch
      setData(data);
      setAppliedUseCurrentEmp(timeuseCurrentEmp);
      dispatch(timeSheet({ data }));
    } catch (error) {
      console.error("Error in attendaceFnSave:", error);
    }
  };

  console.log(getData, "---------------------GETDATA");
  const handleClick = (values) => {
    console.log(values.timemonth, "Month");
    console.log(values.timeyear, "Year");

    navigate("/Apps/Edittimesheetreport", {
      state: { Month: values.timemonth, Year: values.timeyear },
    });
  };
  const explorelistViewData = useSelector(
    (state) => state.exploreApi.explorerowData,
  );
  const explorelistViewColumn = useSelector(
    (state) => state.exploreApi.explorecolumnData,
  );
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const screenChange = (event) => {
    setScreen(event.target.value);
  };
  const VISIBLE_FIELDS = [
    "SLNO",
    "OtDate",
    "NumberOfHours",
    "Status",
    "action",
  ];
  const [funMode, setFunMode] = useState("A");
  const columns = React.useMemo(
    () =>
      explorelistViewColumn
        ? explorelistViewColumn.filter((column) =>
          VISIBLE_FIELDS.includes(column.field),
        )
        : [],
    [explorelistViewColumn],
  );

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") navigate("/");
        if (props === "Close") navigate("/Apps/Chart");
      }
    });
  };
  const [timeempData, settimeempData] = useState(null);
  const [timeproData, settimeproData] = useState(null);
  const handleSelectionEmployeeChange = (newValue) => {
    if (newValue) {
      settimeempData(newValue);
    } else {
      settimeempData(null);
    }
    settimeUseCurrentEmp(false);
  };
  const handleSelectionProjectChange = (newValue) => {
    if (newValue) {
      settimeproData(newValue);
    } else {
      settimeproData(null);
    }
  };
  const [open, setOpen] = React.useState(false);

  const handleDialogOpen = (row) => {
    setSelectedRow(row);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setReason("");
    setSelectedRow(null);
  };
  const [reason, setReason] = useState("");
  

  return (
    <React.Fragment>
      <Paper
        elevation={3}
        sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}
      >
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Typography
              variant="h4"
              sx={{ fontSize: "19px", marginLeft: "10px",color:"#0000D1"}}
            >
              Timesheet ({timeuseCurrentEmp ? EMPNAME : timeempData?.Name ?? EMPNAME})
            </Typography>
          </Box>
          <Box display="flex">
            {/* <Tooltip title="Attendance ">
            <IconButton
              onClick={() => navigate("/Apps/TR217/Attendance")}
              color="primary"
            >
              <ListAltOutlinedIcon />
            </IconButton>
          </Tooltip> */}
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      <Paper elevation={3} sx={{ margin: "10px" }}>
        <Formik
          initialValues={AttInitialvalues}
          enableReinitialize={true}
          onSubmit={(values, { resetForm }) => {
            setTimeout(() => {
              attendaceFnSave(values, resetForm);
            }, 100);
          }}
        >
          {({
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting,
            values,
            handleSubmit,
            resetForm,
            setFieldValue,
          }) => (
            <form
              onSubmit={handleSubmit}
              onReset={() => {
                resetForm();
                settimeproData(null);
                settimeempData(null);
                setFieldValue("timemonth", currentMonthNumber);
                setFieldValue("timeyear", currentYear);
                sessionStorage.removeItem("timeproData");
                sessionStorage.removeItem("timeempData");
                sessionStorage.removeItem("timemonth");
                sessionStorage.removeItem("timeyear");
                dispatch(resetTrackingData());
                settimeUseCurrentEmp(true);
                sessionStorage.setItem("timeuseCurrentEmp", "true");
              }}
            >
              <Box
                display="grid"
                gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                // gap="70px"
                gap={formGap}
                padding={1}
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 4",
                  },
                }}
              >
                <Stack direction="row" spacing={2}>
                  {/* <TextField
                    fullWidth
                    variant="standard"
                    type="text"
                    id="month"
                    name="month"
                    label="Month"
                    value={values.month}
                    focused
                    onChange={handleChange}
                    onBlur={handleBlur}
                    select
                    sx={{
                      "& .MuiFilledInput-root": {
                        backgroundColor: "transparent", // optional: adjust if needed
                      },
                      width: 200,
                    }}
                  >
                    <MenuItem value={"1"}>January</MenuItem>
                    <MenuItem value={"2"}>February</MenuItem>
                    <MenuItem value={"3"}>March</MenuItem>
                    <MenuItem value={"4"}>April</MenuItem>
                    <MenuItem value={"5"}>May</MenuItem>
                    <MenuItem value={"6"}>June</MenuItem>
                    <MenuItem value={"7"}>July</MenuItem>
                    <MenuItem value={"8"}>August</MenuItem>
                    <MenuItem value={"9"}>September</MenuItem>
                    <MenuItem value={"10"}>October</MenuItem>
                    <MenuItem value={"11"}>November</MenuItem>
                    <MenuItem value={"12"}>December</MenuItem>
                  </TextField> */}
                  <TextField
                    fullWidth
                    variant="standard"
                    type="text"
                    id="timemonth"
                    name="timemonth"
                    label="Month"
                    select
                    focused
                    value={values.timemonth}
                    onChange={(e) => {
                      handleChange(e);
                      sessionStorage.setItem("timemonth", e.target.value);
                    }}
                    onBlur={handleBlur}
                    sx={{ width: 200 }}
                  >
                    <MenuItem value={"1"}>January</MenuItem>
                    <MenuItem value={"2"}>February</MenuItem>
                    <MenuItem value={"3"}>March</MenuItem>
                    <MenuItem value={"4"}>April</MenuItem>
                    <MenuItem value={"5"}>May</MenuItem>
                    <MenuItem value={"6"}>June</MenuItem>
                    <MenuItem value={"7"}>July</MenuItem>
                    <MenuItem value={"8"}>August</MenuItem>
                    <MenuItem value={"9"}>September</MenuItem>
                    <MenuItem value={"10"}>October</MenuItem>
                    <MenuItem value={"11"}>November</MenuItem>
                    <MenuItem value={"12"}>December</MenuItem>
                  </TextField>

                  {/* <TextField
                    fullWidth
                    variant="standard"
                    type="number"
                    id="year"
                    name="year"
                    label="Year"
                    value={values.year}
                    inputProps={{ min: "1900", max: "2100", step: "1" }}
                    focused
                    onChange={handleChange}
                    onBlur={handleBlur}
                    sx={{
                      "& .MuiFilledInput-root": {
                        backgroundColor: "transparent",
                      },
                      width: 200,
                    }}
                  /> */}
                  <TextField
                    fullWidth
                    variant="standard"
                    type="number"
                    id="timeyear"
                    name="timeyear"
                    label="Year"
                    focused
                    inputProps={{ min: "1900", max: "2100", step: "1" }}
                    value={values.timeyear}
                    onChange={(e) => {
                      handleChange(e);
                      sessionStorage.setItem("timeyear", e.target.value);
                    }}
                    onBlur={handleBlur}
                    sx={{ width: 200 }}
                  />

                  {/* <Employeeautocomplete */}
                   <TimesheetEmployeeautocomplete
                    name="ProName"
                    label= {is003Subscription ? "Standard" : "Project"}
                    id="ProName"
                    value={timeproData}
                    onChange={(newValue) => {
                      settimeproData(newValue);
                      if (newValue)
                        sessionStorage.setItem(
                          "timeproData",
                          JSON.stringify(newValue),
                        );
                      else sessionStorage.removeItem("timeproData");
                    }}
                    url = {`${listViewurl}?data=${JSON.stringify(queryObj)}`}
                    // url={`${listViewurl}?data={"Query":{"AccessID":"2119",
                    // "ScreenName":"Project","Filter":"parentID=${CompanyID} 
                    // AND EmployeeID=${EMPID}","Any":""}}`}
                  />

                  {/* <Employeeautocomplete
                    name="ProName"
                    label="Project"
                    id="ProName"
                    value={proData}
                    onChange={handleSelectionProjectChange}
                    error={!!touched.ProName && !!errors.ProName}
                    helperText={touched.ProName && errors.ProName}
                    url={`${listViewurl}?data={"Query":{"AccessID":"2119","ScreenName":"Project","Filter":"parentID=${companyID} AND EmployeeID=${EMPID}","Any":""}}`}
                  // 2054
                  /> */}

                  {/* {isManager === "1" && (
                    <Employeeautocomplete
                      sx={{ width: 400 }}
                      name="Employee"
                      label="Employee"
                      id="Employee"
                      value={empData}
                      onChange={handleSelectionEmployeeChange}
                      error={!!touched.empName && !!errors.empName}
                      helperText={touched.empName && errors.empName}
                      url={
                        QA === "Y"
                          ? `${listViewurl}?data={"Query":{"AccessID":"2118","ScreenName":"EMPLOYEETEAMS","Filter":"ProjectID=${proData?.RecordID} AND EmpID NOT IN (${EMPID})","Any":"","CompId":${companyID}}}`
                          : `${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${companyID}}}`
                      }
                    />
                  )} */}
                  {isManager === "1" && (
                    // <Employeeautocomplete
                    <TimesheetEmployeeautocomplete
                      name="Employee"
                      label="Personnel"
                      id="Employee"
                      value={timeempData}
                      onChange={(newValue) => {
                        settimeempData(newValue);
                        settimeUseCurrentEmp(false);
                        if (newValue)
                          sessionStorage.setItem(
                            "timeempData",
                            JSON.stringify(newValue),
                          );
                        else sessionStorage.removeItem("timeempData");
                      }}
                      url={
                        QA === "Y"
                          ? `${listViewurl}?data={"Query":{"AccessID":"2118","ScreenName":"EMPLOYEETEAMS","Filter":"ProjectID=${timeproData?.RecordID} AND EmpID NOT IN (${EMPID}) GROUP BY RecordID","Any":"","CompId":${CompanyID},"VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`
                          // : `${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${CompanyID}}}`
                          //POINT BY NK -->CHANGED ON 04/04/2026 - ACCESS --> 2162 --> PERSONNEL WILL BE CHOSEN UPON MANAGERID AND PROJECTID IN TIMESHEET EMPLOYEES SCREEN
                          : `${listViewurl}?data={"Query":{"AccessID":"2162","ScreenName":"TIMESHEETEMP","Filter":"parentID='${EMPID}' AND DefaultProjectID='${timeproData?.RecordID}'","Any":"","CompId":${CompanyID},"VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`
                      }
                    />
                  )}

                  {/* <FormControlLabel
                    control={
                      <Checkbox
                        checked={useCurrentEmp}
                        onChange={(e) => {
                          setUseCurrentEmp(e.target.checked);
                          setempData(null);
                        }}
                        color="primary"
                      />
                    }
                    label="Self"
                  /> */}
                  <FormControlLabel
                    control={
                      <Checkbox
                      disabled={isManager !== "1"}
                        checked={timeuseCurrentEmp}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          settimeUseCurrentEmp(checked);
                          settimeempData(null);
                          sessionStorage.setItem("timeuseCurrentEmp", checked);
                        }}
                        color="primary"
                      />
                    }
                    label="Self"
                  />
                </Stack>
                <Stack
                  direction="row"
                  spacing={2}
                  display="flex"
                  padding={1}
                  justifyContent="end"
                >
                  <Button type="submit" variant="contained" color="secondary">
                    APPLY
                  </Button>
                  <Button
                    type="reset"
                    variant="contained"
                    // color="error"
                    sx={{ color: "white", backgroundColor: "#2196f3" }}
                    // style={{ color: "#2196f3"}}
                    size="small"
                    onClick={() => handleClick(values)}
                  >
                    More
                  </Button>
                  <Button
                    type="reset"
                    variant="contained"
                    color="error"
                    size="small"
                  >
                    RESET
                  </Button>
                  {ApprovedData?.length > 0 && (
                    <PDFDownloadLink
                      document={
                        <TimeSheetPDF
                          data={ApprovedData}
                          projectName={projectName}
                          managerName={managerName}
                          filters={{
                            Month: values.timemonth,
                            Year: values.timeyear,
                            EmployeeID: timeempData?.Name || EMPNAME,
                            Imageurl: baseurl1,
                            HeaderImg: HeaderImg,
                            FooterImg: FooterImg,
                          }}
                        />
                      }
                      fileName={`Timesheet_${timeempData?.Name || EMPNAME}.pdf`}
                      style={{ color: "#d32f2f", cursor: "pointer" }} // Red for PDF feel
                    >
                      {({ loading }) =>
                        loading ? (
                          <PictureAsPdfIcon
                            sx={{ fontSize: 24, opacity: 0.5 }}
                          />
                        ) : (
                          <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                        )
                      }
                    </PDFDownloadLink>
                  )}

                  {ApprovedData?.length > 0 && (
                    <FaFileExcel
                      size={20}
                      color="#1D6F42"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        TimesheetExcel(
                          ApprovedData,
                          {
                            Month: values.timemonth,
                            Year: values.timeyear,
                            EmployeeID: timeempData?.Name || EMPNAME,
                          },
                          projectName,
                          managerName,
                          // { month: values.month, year: values.year },
                          // empData
                        )
                      }
                    />
                  )}
                </Stack>
              </Box>

              <Box sx={{ gridColumn: "span 4" }}>
                <Box
                  height="500px"
                  // height={dataGridHeight}
                  //marginTop={-1}
                  sx={{
                    "& .MuiDataGrid-root": {
                      // border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      // borderBottom: "none",
                    },
                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      // borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      // borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#d0edec",
                      color: "", // Color for even rows
                    },
                  }}
                >
                  {/* <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    rows={AttendanceData}
                    columns={filteredColumns}
                    disableSelectionOnClick
                    getRowId={(row) => row.RecordID}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onCellClick={(params) => { }}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    components={{
                      Toolbar: AttendanceTool,
                    }}
                    onStateChange={(stateParams) =>
                      setRowCount(stateParams.pagination.rowCount)
                    }
                    // loading={exploreLoading}
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                  /> */}
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    rows={AttendanceData}
                    // columns={AttColumn}
                    columns={filteredColumns}
                    disableSelectionOnClick
                    getRowId={(row) => row.RecordID}
                    pageSize={pageSize}
                    page={page}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPage) => setPage(newPage)}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    components={{ Toolbar: AttendanceTool }}
                    onStateChange={(stateParams) =>
                      setRowCount(stateParams.pagination.rowCount)
                    }
                    // onFilterModelChange={handleFilterChange}
                    loading={timeSheetLoading}
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                  />
                </Box>
              </Box>
            </form>
          )}
        </Formik>
        {/* </Box> */}

        <Dialog open={dialogOpen} onClose={handleDialogClose}>
          <DialogTitle>{"UnLock Reason"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              To unlock this employee, please enter your reason here.
            </DialogContentText>
            <TextField
              autoFocus
              required
              margin="dense"
              id="reason"
              name="reason"
              label="Reason"
              type="text"
              fullWidth
              variant="standard"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>CANCEL</Button>
            <Button onClick={handleUnlock} autoFocus>
              UNLOCK
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </React.Fragment>
  );
};

export default EditTimeSheet;

// "RecordID": "1249",
// "Code": "0",
// "Desc": "",
// "Status": "C",
// "Comment": "Documetation prepare for screens",
// "EmpRecordID": "132",
// "Sortorder": "0",
// "Disable": "N",
// "CreatedDateTime": null,
// "EarecordID": "1658",
// "FRecordID": "16",
// "FunctionCode": "D001",
// "FuntionsName": "Developer",
// "PreRecordID": "1",
// "ProjectCode": "P001",
// "ProjectName": "ESS"
